export const FISH_FINALIZADA = 'FISH_FINALIZADA';
export const fishFinalizada = (fishFinalizada) => ({
  type: FISH_FINALIZADA,
  payload: {
    fishFinalizada: fishFinalizada,
  },
});




// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/fish/fish.action.js